exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "\ndiv[data-v-2adda058] .modal-dialog {\r\n  max-width: 800px;\n}\ndiv[data-v-2adda058] .modal-title {\r\n  font-size: 24px;\n}\ndiv[data-v-2adda058] .modal-body {\r\n  max-height: 500px;\n}\ndiv[data-v-2adda058] .modal-footer__button-secondary {\r\n  border-radius: 4px;\r\n  padding: inherit;\r\n  background: #e30613;\r\n  line-height: 16px;\n}\r\n", ""]);

// exports
